/**
 * EmptyState — friendly, illustrated empty state used across list screens.
 *
 * <EmptyState icon="🎉" title="All quiet — nothing pending" subtitle="Everything's up to date." />
 */
export function EmptyState({ icon = "🎉", title, subtitle, action, testid = "empty-state" }) {
    return (
        <div className="mx-auto my-6 rounded-2xl bg-white border border-gray-100 fx-shadow-card p-8 text-center max-w-lg" data-testid={testid}>
            <div className="mx-auto flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-blue-50 to-indigo-50 text-3xl mb-4 select-none" aria-hidden>
                {icon}
            </div>
            <div className="font-display text-lg font-bold text-[#1E3355]">{title}</div>
            {subtitle && <div className="mt-1 text-sm text-gray-500">{subtitle}</div>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}

export default EmptyState;
